/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, Input} from '@angular/core';
import {MdDialogRef} from './dialog-ref';
/**
 * Button that will close the current dialog.
 */
export class MdDialogClose {
/**
 * Screenreader label for the button.
 */
ariaLabel: string = 'Close dialog';
/**
 * Dialog close input.
 */
dialogResult: any;
/**
 * Dialog close input for compatibility mode.
 * @param {?} value
 * @return {?}
 */
set _matDialogClose(value: any) { this.dialogResult = value; }
/**
 * @param {?} dialogRef
 */
constructor(public dialogRef: MdDialogRef<any>) { }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'button[md-dialog-close], button[mat-dialog-close],' +
            'button[mdDialogClose], button[matDialogClose]',
  host: {
    '(click)': 'dialogRef.close(dialogResult)',
    '[attr.aria-label]': 'ariaLabel',
    'type': 'button', // Prevents accidental form submits.
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ariaLabel': [{ type: Input, args: ['aria-label', ] },],
'dialogResult': [{ type: Input, args: ['md-dialog-close', ] },],
'_matDialogClose': [{ type: Input, args: ['mat-dialog-close', ] },],
};
}

function MdDialogClose_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogClose.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogClose.ctorParameters;
/** @type {?} */
MdDialogClose.propDecorators;
/**
 * Screenreader label for the button.
 * @type {?}
 */
MdDialogClose.prototype.ariaLabel;
/**
 * Dialog close input.
 * @type {?}
 */
MdDialogClose.prototype.dialogResult;
/** @type {?} */
MdDialogClose.prototype.dialogRef;
}

/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
export class MdDialogTitle { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-dialog-title], [mat-dialog-title], [mdDialogTitle], [matDialogTitle]',
  host: {'class': 'mat-dialog-title'},
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDialogTitle_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogTitle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogTitle.ctorParameters;
}

/**
 * Scrollable content container of a dialog.
 */
export class MdDialogContent { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-dialog-content], md-dialog-content, [mat-dialog-content], mat-dialog-content,' +
            '[mdDialogContent], [matDialogContent]',
  host: {'class': 'mat-dialog-content'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDialogContent_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogContent.ctorParameters;
}

/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
export class MdDialogActions { static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-dialog-actions], md-dialog-actions, [mat-dialog-actions], mat-dialog-actions,' +
            '[mdDialogActions], [matDialogActions]',
  host: {'class': 'mat-dialog-actions'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdDialogActions_tsickle_Closure_declarations() {
/** @type {?} */
MdDialogActions.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdDialogActions.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
